import React from 'react';
import PropTypes from 'prop-types';

const ChevronUp = ({ theme, fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 17C21.1164 16.8839 21.2088 16.746 21.2718 16.5941C21.3348 16.4422 21.3672 16.2794 21.3672 16.115C21.3672 15.9506 21.3348 15.7878 21.2718 15.6359C21.2088 15.4841 21.1164 15.3461 21 15.23L12.7 6.92001C12.5131 6.73679 12.2618 6.63416 12 6.63416C11.7383 6.63416 11.4869 6.73679 11.3 6.92001L3.00001 15.23C2.85607 15.3382 2.737 15.4761 2.65084 15.6342C2.56467 15.7924 2.5134 15.9671 2.50049 16.1468C2.48758 16.3264 2.51332 16.5067 2.57599 16.6755C2.63865 16.8444 2.73679 16.9978 2.86377 17.1255C2.99075 17.2532 3.14363 17.3522 3.31211 17.4158C3.48059 17.4795 3.66076 17.5062 3.84045 17.4943C4.02015 17.4824 4.19522 17.4322 4.35384 17.3469C4.51246 17.2616 4.65097 17.1433 4.76001 17L12 9.76001L19.26 17C19.4932 17.2261 19.8052 17.3525 20.13 17.3525C20.4548 17.3525 20.7668 17.2261 21 17Z"
      fill={fill || theme.COLORS.primary}
    />
  </svg>
);

ChevronUp.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default ChevronUp;
